export enum ActiveInactiveStatus {
  Active = 'active',
  Inactive = 'inactive',
}

export enum Application {
  BeSeen = 'beseen',
  BeHeard = 'beheard',
  Pulse = 'pulse',
}
